enum CallBackRequestRoutes {
  List = '/callback-request',
  Item = '/callback-request/:id',
}

export default CallBackRequestRoutes
